import {ScanRepository} from '../repositories/ScanRepository';
import {CaseDetail} from '../entities/CaseDetail';

export class GetCaseDetailUseCase {
  constructor(private readonly scanRepository: ScanRepository) {}

  async execute(caseId: number): Promise<CaseDetail> {
    return await this.scanRepository.getCaseDetail(caseId);
  }
}
